<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container d-print-none" >
                <template #default>   <m-Alert-1 v-bind='{...{},...{}}' :style='""' class="col-lg-12 text-center" >
                <template #default>«ارسال کلیه سفارش‌ها طی ۲ تا ۵ روز کاری پس از ثبت و تأیید نهایی انجام خواهد شد.»   </template>
                </m-Alert-1></template>
                </m-div><m-factor-10 v-bind='{...{"showLogo":true,"showSiteNameInsteadOfLogo":false,"showDeliveryOption":true,"showCartonSize":false},...{}}' :style='""' class="px-5" ></m-factor-10><m-single-page-1 v-bind='{...{"contentLink":"terms"},...{}}' :style='""' class="terms-factor container mb-4" ></m-single-page-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mAlert1 from '@moeinmdn/miw-alpha-components/src/package/Alert/Alert1'; import mFactor10 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor10'; import mSinglePage1 from '@moeinmdn/miw-alpha-components/src/package/Page/Single/SinglePage1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mAlert1,mFactor10,mSinglePage1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
